import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'; // 1. Import hook
import { ExploreTwoTone, VerifiedUserTwoTone, WavingHandTwoTone } from '@mui/icons-material';

// --- Reusable Color Palette ---
const PEACOCK_TEAL = '#007D8C';

const OurPromise = () => {
  const { t } = useTranslation(); // 2. Initialize translation function

  // 3. Define the data array inside the component to use the `t` function
  const promises = [
    {
      icon: <ExploreTwoTone sx={{ fontSize: 40 }} />,
      title: t('promise1_title'),
      text: t('promise1_text')
    },
    {
      icon: <VerifiedUserTwoTone sx={{ fontSize: 40 }} />,
      title: t('promise2_title'),
      text: t('promise2_text')
    },
    {
      icon: <WavingHandTwoTone sx={{ fontSize: 40 }} />,
      title: t('promise3_title'),
      text: t('promise3_text')
    }
  ];

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="lg">
        {/* Section Heading */}
         <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 500,
              mb: 3,
              lineHeight: 1.3,
              fontFamily: 'serif',
              color:'#005F69',
              textAlign: 'center'
            }}
          >
          {t('promise_main_headline')}
        </Typography>

        {/* Features Grid */}
        <Grid container spacing={{ xs: 6, md: 4 }} justifyContent="center" sx={{ mt: 4 }}>
          {promises.map((promise) => (
            <Grid item size={{ xs: 12, sm: 8, md: 4 }} key={promise.title}> {/* Corrected Grid props */}
              <Box sx={{ textAlign: 'center' }}>
                {/* The Icon */}
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 3,
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    color: PEACOCK_TEAL,
                    backgroundColor: 'rgba(0, 125, 140, 0.08)',
                  }}
                >
                  {promise.icon}
                </Box>
                
                {/* The Heading */}
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    fontWeight: 700,
                    fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
                    color: 'text.primary',
                    mb: 1.5,
                  }}
                >
                  {promise.title}
                </Typography>
                
                {/* The Description */}
                <Typography
                  variant="body1"
                  sx={{
                    color: 'text.secondary',
                    px: { xs: 2, md: 0 },
                  }}
                >
                  {promise.text}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurPromise;